// src/contexts/TwilioContext.js
import React, { createContext, useContext, useRef } from 'react'

const TwilioContext = createContext(null)

export const TwilioProvider = ({ children }) => {
    const deviceRef = useRef(null)
    const callRef = useRef(null)
    
    return (
        <TwilioContext.Provider value={{ deviceRef, callRef }}>
            {children}
        </TwilioContext.Provider>
    )
}

export const useTwilio = () => {
    const context = useContext(TwilioContext)
    if (!context) {
        throw new Error('useTwilio must be used within TwilioProvider')
    }
    return context
}